<!-- 图片新闻资讯列表：模块头+图片+标题+链接 -->
<template>
  <div class="info-block">
    <a
      v-if="info.link_url"
      :href="info.link_url"
      class="info-block-a"
      v-bind:style="{ backgroundImage: 'url(' + info.cover_img + ')' }"
      target="_blank"
    >
      <div class="title">
        {{
          info.title.length > titleLength
            ? info.title.substring(0, titleLength) + "..."
            : info.title
        }}
      </div>
      <div class="label">
        {{
          info.description.length > labelLength
            ? info.description.substring(0, labelLength) + "..."
            : info.description
        }}
      </div>
      <div class="date">{{ displayTime }}</div>
    </a>
    <router-link
      v-else
      class="info-block-a"
      :to="'/hyzx/details/' + info.id"
      v-bind:style="{ backgroundImage: 'url(' + info.cover_img + ')' }"
      target="_blank"
    >
      <div class="title">
        {{
          info.title.length > titleLength
            ? info.title.substring(0, titleLength) + "..."
            : info.title
        }}
      </div>
      <div class="label">
        {{
          info.description.length > labelLength
            ? info.description.substring(0, labelLength) + "..."
            : info.description
        }}
      </div>
      <div class="date">{{ displayTime }}</div>
    </router-link>
  </div>
</template>
<script>
import { date } from "../utils/utils";

export default {
  name: "InfoBlock07",
  props: {
    info: {
      type: Object,
      default: {},
    },
    titleLength: {
      type: Number,
      default: 40,
    },
    labelLength: {
      type: Number,
      default: 80,
    },
  },
  data() {
    return {};
  },
  computed: {
    displayTime() {
      const releaseTime = Number(this.info && this.info.release_time);
      if (releaseTime > 0) {
        return date(releaseTime, "yyyy-MM-dd");
      }
      const createTime = (this.info && this.info.create_time) || "";
      return createTime.length > 10 ? createTime.substring(0, 10) : createTime;
    },
  },
  created: function () {
    console.log("InfoBlock07 created");
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a {
  display: block;
  position: relative;
  box-sizing: content-box;
  height: 120px;
  padding: 0px 10px 0px 220px;
  margin-bottom: 15px;
  border: 1px solid #fff;
  background-color: #fff;
  background-size: 200px 100%;
  background-repeat: no-repeat;
  background-position: 0px 0px;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover {
  border: 1px solid #eee;
  box-shadow: 0px 0px 0.5px 0px #eee;
}

.info-block .info-block-a:hover > .title {
  color: var(--color6);
}

.info-block .info-block-a:hover > .label {
  color: var(--color6);
}

.info-block-a .title {
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #282a2b;
  line-height: 30px;
}

.info-block-a .label {
  display: block;
  font-size: 12px;
  padding-top: 6px;
  color: #888888;
  line-height: 20px;
}

.info-block-a .date {
  display: block;
  height: 20px;
  padding-left: 20px;
  position: absolute;
  bottom: 15px;
  font-size: 12px;
  color: #888888;
  line-height: 20px;
  //background: red;
  background-image: url(./../../assets/clock.png);
  background-size: 15px 15px;
  background-repeat: no-repeat;
  background-position: 0px 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/block/InfoBlock07.vue